import { View, StyleSheet } from "react-native";
import { ArrowLeft } from "@phosphor-icons/react/dist/csr/ArrowLeft";
import { Eye } from "@phosphor-icons/react/dist/csr/Eye";
import CustomText from "../common/general/CustomText/CustomText";
import CustomButton from "../common/general/CustomButton/CustomButton";

const PreviewIcon = () => <Eye color="#3E68FE" size={16} />;
const BackIcon = () => <ArrowLeft color="#3E68FE" size={16} />;

interface PreviewModeBannerProps {
  courseName: string;
  onBackToAdmin: () => void;
}

const PreviewModeBanner = ({ courseName, onBackToAdmin }: PreviewModeBannerProps) => {
  return (
    <View style={styles.banner}>
      <View style={styles.bannerContent}>
        <View style={styles.leftContent}>
          <PreviewIcon />
          <CustomText
            text="Preview Mode"
            size="s"
            weight="medium"
            useTranslationText={false}
            style={styles.previewText}
          />
          <View style={styles.divider} />
          <CustomText
            text={`Viewing "${courseName}" as a student`}
            size="s"
            useTranslationText={false}
            style={styles.courseText}
          />
        </View>

        <CustomButton
          text="Back to Admin View"
          leftIcon={<BackIcon />}
          styleType="primaryLight"
          size="s"
          onPress={onBackToAdmin}
          useTranslationText={false}
          style={styles.backButton}
        />
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  banner: {
    backgroundColor: "#EEF4FF",
    borderBottomWidth: 1,
    borderBottomColor: "#D1D5DB",
    paddingVertical: 8,
    paddingHorizontal: 16,
    zIndex: 1000,
  },
  bannerContent: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    maxWidth: 1340,
    marginHorizontal: "auto",
    width: "100%",
  },
  leftContent: {
    flexDirection: "row",
    alignItems: "center",
    gap: 8,
  },
  previewText: {
    color: "#3E68FE",
  },
  divider: {
    width: 1,
    height: 16,
    backgroundColor: "#D1D5DB",
  },
  courseText: {
    color: "#64748B",
  },
  backButton: {
    backgroundColor: "#fff",
    borderWidth: 1,
    borderColor: "#3E68FE",
    paddingHorizontal: 12,
    paddingVertical: 6,
  },
});

export default PreviewModeBanner;
